import theme from '../../theme/theme';

const {
  colors: { subtitle, black_text },
} = theme;

const styles = {
  wrapper: {
    width: '17.875em',
  },

  title: {
    color: black_text,
    fontFamily: 'semibold',
    fontSize: '1.5em',
    letterSpacing: '-0.031em',
    display: 'flex',
    justifyContent: 'center',
  },

  subtitle: {
    fontSize: '1.1em',
    color: subtitle,
    justifyContent: 'center',
    textAlign: 'center',
  },
};

export default styles;
